class SqmCalculator extends HTMLElement {
  constructor() {
    super();

    this.onInput = this.onInput.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);
  }

  sanitizeVariant = (variant) => {
    return variant.replace(/[^0-9.]+/g, "");
  };

  setVariant = (variant) => {
    this.selectVariant = variant;
    this.variantSize = this.sanitizeVariant(variant.option1);
  };

  initQuantitySelector = () => {
    this.quantitySelector = document.querySelector("quantity-selector");
    this.quantityInput = this.quantitySelector.querySelector("input");
  };

  initTotalPriceSelector = () => {
    this.totalPrice = document.querySelector("[data-sqm-total-price]");
  };

  initQuantitySelector = () => {
    this.quantitySelector = document.querySelector("quantity-selector");
    this.quantityInput = this.quantitySelector.querySelector("input");
  };

  initLengthCalculator = () => {
    this.sqmLengthInput = this.querySelector(".sqm-length-calculator");
    this.unitPrice = this.querySelector("[data-sqm-unit-price]").innerHTML;

    this.sqmLengthInput.addEventListener("input", (e) => {
      this.sqmLengthInput.addEventListener("input", this.onInput);
    });
    this.calculateQuantity(400, 100);
  };

  onInput(e) {
    const value = parseInt(e.target.value, 10);
    this.updateQuantity(value);
  }

  onVariantChange(e) {
    this.setVariant(e.detail.variant);
    const value = parseInt(this.sqmLengthInput.value, 10);
    this.updateQuantity(value);
  }

  initVariantSize = () => {
    this.selectVariant = JSON.parse(document.querySelector("script[data-variant]")?.textContent || {});
    if (!this.selectVariant) return;

    this.variantSize = this.sanitizeVariant(this.selectVariant.option1);

    document.addEventListener("variant:change", this.onVariantChange);
  };

  updateQuantity = (quantity) => {
    const isNumeric =
      (typeof quantity === "number" || (typeof quantity === "string" && quantity.trim() !== "")) && !isNaN(quantity);
    if (!isNumeric) {
      quantity = 1;
    }

    if (this.variantSize === undefined) {
      this.variantSize = 1;
    }

    const newVariantQuantity = this.calculateQuantity(this.variantSize, parseInt(quantity, 10));
    this.quantityInput.value = newVariantQuantity;
    this.quantityInput._onValueChanged();

    const newPrice = this._currencyFormatter
      .format((Number(this.unitPrice) * newVariantQuantity) / 100)
      .replace(/\$/g, "$$$$");

    this.totalPrice.innerHTML = newPrice;
  };

  calculateQuantity(variantSize, cm = 1) {
    let sqm = (variantSize * cm) / 10000;

    sqm = Math.ceil(sqm);
    sqm = Math.max(1, sqm);

    return sqm;
  }

  init = () => {
    this.initQuantitySelector();
    this.initTotalPriceSelector();
    this.initLengthCalculator();
    this.initVariantSize();

    this._currencyFormatter = new Intl.NumberFormat(Shopify.locale, {
      style: "currency",
      currency: Shopify.currency.active,
    });
  };

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    if (this.sqmLengthInput) {
      this.sqmLengthInput.removeEventListener("input", this.onInput);
    }

    document.removeEventListener("variant:change", this.onVariantChange);
  }
}

customElements.define("sqm-calculator", SqmCalculator);
